import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { useFpB2bPaymentService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-payment-service'
import { useFpCampaignCartService } from '@cart-services/hooks/useFpCampaignCartService'
import { useFpCampaignPaymentService } from '@cart-services/hooks/useFpCampaignPaymentService'
import { datadogRum } from '@datadog/browser-rum'
import { removeStorageItem, STORAGE_EVENT } from '@utils'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom-v5'
import { LoaderBuygather } from '../components/LoaderFullPage/LoaderBuygather'
import { type Environment } from '../types/environment'
import { clearToken } from '../utils/clear-token'

interface LogoutProps {
  environment: Environment
  campaignId: number
}

export function Logout(props: LogoutProps) {
  const { environment, campaignId } = props
  const history = useHistory()
  const { campaignCodeFromUrl } = useCampaignCode()
  const { resetCartValues: resetMerchantCartValues } = useFpB2bCartService(campaignId, Platform.MERCHANT)
  const { resetPaymentTransaction: resetMerchantPaymentTransaction } = useFpB2bPaymentService({
    campaignId,
    campaignCode: campaignCodeFromUrl,
    platform: Platform.MERCHANT,
  })
  const { resetCartValues: resetCampaignCartValues } = useFpCampaignCartService(campaignId)
  const { resetPaymentTransaction: resetCampaignPaymentTransaction } = useFpCampaignPaymentService({ campaignId })

  useEffect(() => {
    removeStorageItem('deliveryInfo', STORAGE_EVENT.sessionStorage)
    clearToken({ campaignCodeFromUrl })
    datadogRum.clearUser()
    resetMerchantCartValues()
    resetMerchantPaymentTransaction()
    resetCampaignCartValues()
    resetCampaignPaymentTransaction()

    if (environment === 'campaign') {
      window.location.replace(`/campaigns/${campaignCodeFromUrl}`)
    }
    else if (environment === 'merchant') {
      window.location.replace(`/merchant/${campaignCodeFromUrl}`)
    }
  }, [campaignCodeFromUrl, environment, history, resetCampaignCartValues, resetCampaignPaymentTransaction, resetMerchantCartValues, resetMerchantPaymentTransaction])

  return <LoaderBuygather fontSize={60} />
}
